<template>
  <div>
    <div class="help_Info_right fr">
      <div class="help_Info_right_top fl">配送说明</div>
      <div class="help_Info_right_bootm shoppstep fl">
        <dl>
          <dt>配送说明</dt>
          <dd>1) 配送时间：订单提交确认后，西始将第一时间为您安排发货，现货产品发货时间为1-3个工作日，货期产品请以实际到货为准；</dd>
          <dd>2) 配送范围：目前西始物流的配送范围包括合作物流覆盖的所有相关区域。</dd>
          <dd>3) 运费问题：订单含税实付金额满3000元免运费，您下单之后，可以快递，物流等方式进行配送。</dd>
          <dd>
            <strong>含税实付金额：是指订单实际支付金额，如客户实际支付金额小于3000元，按照以下政策执行。</strong>
          </dd>
          <dd>
            <strong>规则如下：</strong>
          </dd>
          <dd>
            <dl>
              <dd>1）订单含税实付金额不满3000元，运费请咨询客服，商品大小、重量、普通地区、偏远地区（新疆维吾尔自治区、内蒙古自治区、宁夏回族自治区、西藏自治区、青海省、海南省、港澳台）等因素皆会影响运费。</dd>
              <dd>2）针对退换货的运费：</dd>
              <dd>a）若退换货是由西始原因导致，则针对退换货部分的来回运费由西始承担；</dd>
              <dd>b）若退换货是由客户原因导致，则针对退换货部分的来回运费由客户自行承担；（若仅退货，则仅需要承担退回部分运费）</dd>
              <dd>c）若退货导致订单金额不满3000元，则需补回寄出的运费。</dd>
              <dd>如有任何疑问，请拨打西始热线电话：400-665-8016 我们将竭诚为您服务。</dd>
            </dl>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "explans"
};
</script>

<style>
</style>
